<template>
    <div>
        <zipcode-input
                :inputId="formId + '_zipcode'"
                :inputLbl="lblShipping.zipcode"
                :inputMinLength="5"
                :inputMaxLength="5"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="zipcodeError"
                v-model="address.zipcode"
                @onZipcodeChange="onZipcodeChange()"
        ></zipcode-input>
        <div class="wrap-input">
            <div :class="{'input-box-error': !isFirstSave && isShowErrorLbl && !provinceError.isValid}">
                <b-dropdown
                    class="ddl-input"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_province'"
                    :text="address.provinceName || lblShipping.province.placeholder">
                    <b-dropdown-item
                        :disabled="true">
                        {{lblShipping.province.placeholder}}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(province, index) in arrFilteredProvince"
                        :key="index" @click="selectProvince(province)">
                        {{ locale == 1033 ? province.provinceNameEN : province.provinceName }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !provinceError.isValid">{{provinceError.msg}}</div>
        </div>
        <div class="wrap-input">
            <div :class="{'input-box-error': !isFirstSave && isShowErrorLbl && !districtError.isValid}">
                <b-dropdown
                    class="ddl-input"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_district'"
                    :text="address.districtName || lblShipping.district.placeholder">
                    <b-dropdown-item
                        :disabled="true">
                        {{lblShipping.district.placeholder}}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(district, index) in arrFilteredDistrict"
                        :key="index" @click="selectDistrict(district)">
                        {{ locale == 1033 ? district.districtNameEN : district.districtName }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !districtError.isValid">{{districtError.msg}}</div>
        </div>
        <div class="wrap-input">
            <div :class="{'input-box-error': !isFirstSave && isShowErrorLbl && !subDistrictError.isValid}">
                <b-dropdown
                    class="ddl-input"
                    variant="ddl-input"
                    menu-class="ddl-menu"
                    :inputId="formId + '_subdistrict'"
                    :text="address.subDistrictName || lblShipping.subdistrict.placeholder">
                    <b-dropdown-item
                        :disabled="true">
                        {{lblShipping.subdistrict.placeholder}}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-for="(subdistrict, index) in arrFilteredSubDistrict"
                        :key="index" @click="selectSubDistrict(subdistrict)">
                        {{ locale == 1033 ? subdistrict.subdistrictNameEN : subdistrict.subdistrictName }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="error-text"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !subDistrictError.isValid">{{subDistrictError.msg}}</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import BzbsAddress from '@/core/Address/service/BzbsAddress.js';
import Locale from '@/helper/locale/Locale.js';
import ZipcodeInput from '@/components/Input/Zipcode.vue';
/**
 * @property {object} address (required) Address data model.
 * @property {string} formId (optional) Text for id.
 * @property {object} lblShipping (required) Text for component.
 * @property {object} isFirstSave (required) Show/Hide Error.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide error label under input
 * @property {object} zipcodeError (required) Validate status.
 * @property {object} provinceError (required) Validate status.
 * @property {object} districtError (required) Validate status.
 * @property {object} subDistrictError (required) Validate status.
 *
 * //@property {object} busModal (required) Control modal.
 */
export default {
    name: 'FormAddressDropDown',
    components: {
        ZipcodeInput
    },
    props: {
        lblShipping: Object,
        formId: String,
        address: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        zipcodeError: Object,
        provinceError: Object,
        districtError: Object,
        subDistrictError: Object,

        // busModel: Object
    },
    data: function () {
        return {
            locale: Locale.getLocaleCode(),
            arrProvince: [],
            arrDistrict: [],
            arrSubDistrict: [],
            arrFilteredProvince: [],
            arrFilteredDistrict: [],
            arrFilteredSubDistrict: [],
        };
    },
    mounted: function () {
        //Validate zipcode and Setup select field.
        if(!this.address) return;
        if(Vue.validator.validateZipCode(this.address.zipcode)) {
            this.onZipcodeChange();
        }

        this.validateSelect();
    },
    methods: {
        //Event
        selectProvince: function (province) {
            if(!province) return;

            this.filterDistrictByProvince(province);
        },
        selectDistrict: function (district) {
            if(!district) return;

            this.filterSubDistrictByDistrict(district);
        },
        selectSubDistrict: function (subdistrict) {
            if(!subdistrict) return;

            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName = this.locale == 1033
                ? subdistrict.subdistrictNameEN
                : subdistrict.subdistrictName;
        },
        onZipcodeChange: function () {
            if (Util.validateZipCode(this.address.zipcode)) {
                BzbsAddress.apiGetProvinceFilterByZipcode(this.address.zipcode).subscribe((data) => {
                    //Reset array.
                    this.resetArrAddress();
                    // check not exists zipcode validation from return lists
                    if (data == null){
                        this.zipcodeError.isValid = false;
                        this.zipcodeError.msg = this.lblShipping.zipcode.invalid;
                    }
                    else{
                        //Setup address array.
                        this.arrProvince = data.listProvince;
                        this.arrDistrict = data.listDistrict;
                        this.arrSubDistrict = data.listSubDistrict;
                        this.initialAddressDDL();
                    }
                }, (err) => {
                    console.log(err);
                });
            } else {
                this.resetSelectValue();
                this.resetArrAddress();
                this.validateSelect();
            }
        },
        //Method
        initialAddressDDL: function () {
            if(this.arrProvince.length === 0) return;

            //Setup province data.
            // var self = this;
            var province;
            if(!this.address.provinceCode) {
                province = this.arrProvince[0];
            } else {
                // province = this.arrProvince.filter(function (item) {
                //     return (item.provinceCode == self.address.provinceCode);
                // });
                province = this.arrProvince.find((item) => {
                    return (item.provinceCode == this.address.provinceCode);
                });
            }
            this.arrFilteredProvince.push.apply(this.arrFilteredProvince, this.arrProvince);

            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName = this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;

            this.filterDistrictByProvince(province);
        },
        resetSelectValue: function () {
            this.address.provinceCode = null;
            this.address.districtCode = null;
            this.address.subDistrictCode = null;
            this.address.provinceName = '';
            this.address.districtName = '';
            this.address.subDistrictName = '';
        },
        resetArrAddress: function () {
            this.arrProvince.length = 0;
            this.arrDistrict.length = 0;
            this.arrSubDistrict.length = 0;
            this.arrFilteredProvince.length = 0;
            this.arrFilteredDistrict.length = 0;
            this.arrFilteredSubDistrict.length = 0;
        },
        validateSelect: function () {
            if(this.address.provinceCode) {
                this.provinceError.isValid = true;
                this.provinceError.msg = '';
            } else {
                this.provinceError.isValid = false;
                this.provinceError.msg = this.lblShipping.province.required;
            }

            if(this.address.districtCode) {
                this.districtError.isValid = true;
                this.districtError.msg = '';
            } else {
                this.districtError.isValid = false;
                this.districtError.msg = this.lblShipping.district.required;
            }

            if(this.address.subDistrictCode) {
                this.subDistrictError.isValid = true;
                this.subDistrictError.msg = '';
            } else {
                this.subDistrictError.isValid = false;
                this.subDistrictError.msg = this.lblShipping.subdistrict.required;
            }
        },
        filterDistrictByProvince: function (province) {
            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName = this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;
            //Setup district data.
            var allfilteredDistrict = this.arrDistrict.filter(function (item) {
                return (item.provinceCode == province.provinceCode);
            });
            // this.arrFilteredDistrict.push.apply(this.arrFilteredDistrict, allfilteredDistrict);
            this.arrFilteredDistrict = allfilteredDistrict

            //Set selected item.
            // var self = this;
            var district;
            var filteredByDistrictCode;
            if(!this.address.districtCode) {
                district = allfilteredDistrict[0]
            } else {
                filteredByDistrictCode = this.arrFilteredDistrict.filter((item) => {
                    return (item.districtCode == this.address.districtCode);
                });

                district = filteredByDistrictCode && filteredByDistrictCode.length > 0
                    ? filteredByDistrictCode[0]
                    : allfilteredDistrict[0];
            }

            //Filter subdistrict.
            this.filterSubDistrictByDistrict(district);
        },
        filterSubDistrictByDistrict: function (district) {
            //Fill data.
            this.address.districtCode = district.districtCode;
            this.address.districtName = this.locale == 1033
                    ? district.districtNameEN
                    : district.districtName;
            //Setup subdistrict data.
            var allfilteredSubDistrict = this.arrSubDistrict.filter(function (item) {
                return (item.districtCode == district.districtCode);
            });
            this.arrFilteredSubDistrict = allfilteredSubDistrict;
            // this.arrFilteredSubDistrict.push.apply(this.arrFilteredSubDistrict, allfilteredSubDistrict);

            //Set selected item.
            // var self = this;
            var subdistrict;
            var filteredBySubDistrictCode;
            if(!this.address.subDistrictCode) {
                subdistrict = allfilteredSubDistrict[0]
            } else {
                filteredBySubDistrictCode = this.arrFilteredSubDistrict.filter((item) => {
                    return (item.subdistrictCode == this.address.subDistrictCode);
                });

                subdistrict = filteredBySubDistrictCode && filteredBySubDistrictCode.length > 0
                    ? filteredBySubDistrictCode[0]
                    : allfilteredSubDistrict[0];
            }

            //Fill data.
            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName = this.locale == 1033
                    ? subdistrict.subdistrictNameEN
                    : subdistrict.subdistrictName;

            this.validateSelect();
        },
    }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
    @import "@/style/input/Text.scss";
    .wrap-input {
        @extend %input-base;
    }
</style>
